import React, {Component} from 'react'

export default class CurrencyInput extends Component {

    constructor(props){
        super(props)

        this.handleChange = this.handleChange.bind(this)
    }

    componentWillMount() {
        this.props.onChange(this.convertToCurrency(this.props.value))
    }

    handleChange(event) {
        this.props.onChange(this.convertToCurrency(event.target.value));
    }

    convertToCurrency(input) {
        let value = input.toString()
        value = value.replace(/[^0-9.]/g,'');
        value = value.replace(/\.+/g,'.');
        value = value.replace(/(.*\.[0-9][0-9]?).*/g,'$1');
        value = value.replace(/^0+(.*)$/,'0$1');
        value = value.replace(/^0([^.].*)$/,'$1');
        return value;
    }

    render(){
        return <input type="text" onChange={this.handleChange} value={this.props.value} className={'form-control'} />
    }

}


// WEBPACK FOOTER //
// ./src/componentsTopsa/currencyInput/CurrencyInput.js